module.exports = __webpack_public_path__ + "static/media/california_forel.35dc467a.webp";